/**
 * web/src/styles/inlineStyles.ts —— 组件内联样式 **单源归位**（FE-N-3；AUD3B/L-IA-FEN234）。
 * 原 8 处内联样式模板（原为模块级声明，名 STYLE；源件 <style scoped> 译入件）按动作列「归 styles/」上收。
 * 消费方 `import { xxxStyle as STYLE } from "…/styles/inlineStyles"`（运行时注入 <style>，行为不变）。
 */

/** components/ShellOverlay.tsx（逐字平移，零改动） */
export const shellOverlayStyle = `
.xg-shell-overlay {
  pointer-events: none; /* §6 层容器永不挡下方 */
  position: fixed; inset: 0; z-index: 55; /* 与新树 shell.css 浮层座位同档 */
  display: flex; flex-direction: column; align-items: flex-end;
  gap: var(--xg-space-xs); padding: var(--xg-space-md);
}
.xg-shell-overlay__item { pointer-events: none; } /* 默认不拦截；opt-in 经条目 inline */
.xg-shell-overlay__toast {
  display: inline-flex; align-items: center;
  padding: var(--xg-space-xs) var(--xg-space-md);
  border-radius: var(--xg-radius-md);
  background: var(--xg-surface-raised); color: var(--xg-text-primary);
  border: 1px solid var(--xg-border-base);
  font-size: var(--xg-font-size-caption);
  box-shadow: var(--xg-elevation-panel);
}
.xg-shell-overlay__toast--success { border-color: var(--xg-state-success); }
.xg-shell-overlay__toast--warning { border-color: var(--xg-state-warning); }
.xg-shell-overlay__toast--danger { border-color: var(--xg-state-danger); }
.xg-shell-overlay__badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: var(--xg-space-xl); height: var(--xg-space-xl);
  padding: 0 var(--xg-space-2xs);
  border-radius: var(--xg-space-sm); /* 胶囊全圆（18 高 ⇒ 9 圆角，同 shell.css .xg-badge） */
  background: var(--xg-accent); color: var(--xg-text-inverse);
  font-size: var(--xg-font-size-caption); font-weight: var(--xg-fw-semibold);
}
.xg-shell-overlay__pill {
  display: inline-flex; align-items: center;
  padding: var(--xg-space-2xs) var(--xg-space-xs);
  border-radius: var(--xg-space-sm);
  background: var(--xg-blue-100); color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
}
`;

/** components/rightbar/FilesTabBody.tsx（逐字平移，零改动） */
export const filesTabBodyStyle = `
.xg-files-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-family: var(--xg-font-family-ui);
  font-size: var(--xg-font-size-content);
  color: var(--xg-text-primary);
}

.xg-files-tab__head {
  display: flex;
  align-items: center;
  gap: var(--xg-space-xs);
  padding: var(--xg-space-xs) var(--xg-space-sm);
  border-bottom: 0.5px solid var(--xg-border-subtle);
  flex: none;
}

.xg-files-tab__count {
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-tertiary);
}

.xg-files-tab__refresh {
  margin-left: auto;
  min-height: 24px;
  padding: 0 var(--xg-space-xs);
  border: 0.5px solid var(--xg-border-subtle);
  border-radius: var(--xg-radius-block);
  background: var(--xg-surface-sunken);
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
  cursor: pointer;
}

.xg-files-tab__refresh:hover,
.xg-files-tab__refresh:focus-visible {
  color: var(--xg-text-primary);
  border-color: var(--xg-border-focus);
}

.xg-files-tab__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: var(--xg-space-2xs) 0;
}

.xg-files-tab__hint {
  padding: var(--xg-space-md);
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

.xg-files-tab__error {
  padding: var(--xg-space-md);
  color: var(--xg-state-danger-fg);
  font-size: var(--xg-font-size-caption);
}

.xg-files-tab__group-head {
  display: flex;
  align-items: center;
  gap: var(--xg-space-2xs);
  width: 100%;
  /* ★20260922（全量审计 R6 · 静默失真）：原写 \`var(--xg-row-h, 28px)\`，而 \`--xg-row-h\` 定义为
     **36px**（\`styles/tokens/alias.css:140\`）⇒ fallback 永不生效、本行一直渲染 36px。
     只删假 fallback（渲染零变化）；「36 还是 28」＝尺寸档缺失，登记为待设计裁决项。 */
  min-height: var(--xg-row-h);
  padding: 0 var(--xg-space-sm);
  border: none;
  background: transparent;
  color: var(--xg-text-secondary);
  font-family: inherit;
  font-size: var(--xg-font-size-caption);
  text-align: left;
  cursor: pointer;
}

.xg-files-tab__group-head:hover,
.xg-files-tab__group-head:focus-visible {
  color: var(--xg-text-primary);
}

.xg-files-tab__group-count {
  margin-left: auto;
  color: var(--xg-text-tertiary);
}

.xg-files-tab__rows {
  margin: 0;
  padding: 0;
  list-style: none;
}

.xg-files-tab__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;   /* ★20260921：时间戳另起一行（行外右下）⇒ 允许换行 */
  gap: var(--xg-space-2xs);
  padding: 0 var(--xg-space-xs) 0 var(--xg-space-sm);
}

/* ★20260921（大王报障② 形态）：时间戳占满一整行、靠右下、caption 小号、tertiary —— 不挤文件行 */
.xg-files-tab__time {
  flex: 0 0 100%;
  text-align: right;
  padding: 0 var(--xg-space-2xs) 2px 0;
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-tertiary);
}

.xg-files-tab__row:hover {
  background: var(--xg-surface-raised);
}

.xg-files-tab__open {
  display: flex;
  align-items: center;
  gap: var(--xg-space-2xs);
  flex: 1;
  min-width: 0;
  /* 同上：删假 fallback（本处为 \`.xg-files-tab__open\`，与组头同一登记项） */
  min-height: var(--xg-row-h);
  padding: 0;
  border: none;
  background: transparent;
  color: var(--xg-text-primary);
  font-family: inherit;
  font-size: var(--xg-font-size-content);
  text-align: left;
  cursor: pointer;
}

/* ★20260922（全量审计 P1-5）：环宽由 \`1px\`（**全仓唯一的 1px 环**）收敛到全局标准 \`2px\`
   （\`styles/a11y.css:23-24\`），并显式补 offset 2px（原先缺省＝0，环贴字）。 */
.xg-files-tab__open:focus-visible {
  outline: 2px solid var(--xg-border-focus);
  outline-offset: 2px;
}

.xg-files-tab__name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.xg-files-tab__size {
  flex: none;
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

.xg-files-tab__download {
  flex: none;
  min-height: 24px;
  padding: 0 var(--xg-space-2xs);
  border: 0.5px solid var(--xg-border-subtle);
  border-radius: var(--xg-radius-chip);
  background: transparent;
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
  cursor: pointer;
}

.xg-files-tab__download:hover,
.xg-files-tab__download:focus-visible {
  color: var(--xg-text-primary);
  border-color: var(--xg-border-focus);
}
`;

/** components/rightbar/ProgressTabBody.tsx（逐字平移，零改动） */
export const progressTabBodyStyle = `
.xg-progress-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-family: var(--xg-font-family-ui);
  font-size: var(--xg-font-size-content);
  color: var(--xg-text-primary);
}

.xg-progress-tab__hint {
  padding: var(--xg-space-md);
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

/* ── ★20260925 编排步骤聚合段 ──────────────────────────────────────────
   折叠头＝真 button（\`aria-expanded\` 双向）；展开区就地（\`v-if\`，无弹层无 teleport）。
   本段只裁剪/排版，**不自己滚动**；滚动只落在 \`__orch-body\`（卡根 \`.xg-progress-tab\` 不写 \`overflow-y\`）。 */
.xg-progress-tab__orch {
  flex: none;
  min-width: 0;
  padding: var(--xg-space-2xs) 0;
  border-bottom: 1px solid var(--xg-border-subtle);
}

.xg-progress-tab__orch-head {
  display: flex;
  align-items: center;
  gap: var(--xg-space-xs);
  width: 100%;
  min-width: 0;
  min-height: var(--xg-row-h);
  margin: 0;
  padding: 0 var(--xg-space-sm);
  border: none;
  border-radius: var(--xg-radius-chip);
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.xg-progress-tab__orch-head:hover {
  background: var(--xg-surface-raised);
}

.xg-progress-tab__orch-head:focus-visible {
  outline: 2px solid var(--xg-border-focus);
  outline-offset: -2px;
}

.xg-progress-tab__orch-caret {
  flex: none;
  width: 16px;
  color: var(--xg-text-secondary);
}

.xg-progress-tab__orch-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
}

.xg-progress-tab__orch-action {
  flex: none;
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

/* 展开区＝固定高度 ＋ 内滚（复用既有 L2 令牌 \`--xg-max-h-output\`「输出窗：终端/日志滚动区」＝224px，
   先例口径同 NodeDeliveryRow／ThinkingCard）；\`contain\` 滚到底不带飞外层，\`gutter\` 显隐不跳宽。
   🔴 20261005 F3 实测：新树**全树未定义**该令牌（「src/styles/**」无 --xg-max-h-output，而本件／
   ChainRow／NodeDeliveryRow／toolRow 四处均在用）⇒ 声明失效＝**封顶未生效**。本件按令取 224px
   作 **CSS 变量兜底**（var(--token, 224px)：令牌定义一旦补上即自动以令牌为准，本件不改数）；
   令牌定义归属「src/styles/tokens/」（非本批工作面）⇒ 已登记卡点交 main。 */
.xg-progress-tab__orch-body {
  max-height: var(--xg-max-h-output, 224px);
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  overflow-wrap: anywhere;
  padding: 0 var(--xg-space-sm);
}

.xg-progress-tab__orch-list {
  margin: var(--xg-space-2xs) 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.xg-progress-tab__orch-row {
  display: flex;
  align-items: baseline;
  gap: var(--xg-space-xs);
  font-size: var(--xg-font-size-caption);
  line-height: 20px;
  color: var(--xg-text-secondary);
}

.xg-progress-tab__orch-at {
  flex: none;
  min-width: 4.5em;
  color: var(--xg-text-tertiary);
  font-variant-numeric: tabular-nums;
}

.xg-progress-tab__orch-no {
  flex: none;
  color: var(--xg-text-primary);
  font-variant-numeric: tabular-nums;
}

.xg-progress-tab__orch-tool {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--xg-text-secondary);
}

.xg-progress-tab__orch-state {
  flex: none;
  color: var(--xg-text-tertiary);
}

.xg-progress-tab__orch-state--bad {
  color: var(--xg-state-warning-fg);
}

.xg-progress-tab__orch-err {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--xg-state-warning-fg);
}

.xg-progress-tab__orch-count,
.xg-progress-tab__orch-degraded {
  margin: var(--xg-space-2xs) 0 0;
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

.xg-progress-tab__orch-degraded {
  color: var(--xg-state-warning-fg);
}

.xg-progress-tab__list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  margin: 0;
  padding: var(--xg-space-2xs) 0;
  list-style: none;
}

.xg-progress-tab__row {
  display: flex;
  align-items: baseline;
  gap: var(--xg-space-xs);
  /* ★20260922（全量审计 R6 · 静默失真）：原写 \`var(--xg-row-h, 28px)\`，而 \`--xg-row-h\` 定义为
     **36px**（\`styles/tokens/alias.css:140\`）⇒ fallback **永不生效**、本行一直渲染 36px。
     此处只删掉与定义不符的假 fallback（**渲染零变化**，也不再误导后来者）。
     「右栏紧凑行该 36 还是 28」＝尺寸档缺失，登记为**待设计裁决项**，未擅自改值。 */
  min-height: var(--xg-row-h);
  padding: 0 var(--xg-space-sm);
}

.xg-progress-tab__row:hover {
  background: var(--xg-surface-raised);
}

.xg-progress-tab__at {
  flex: none;
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

.xg-progress-tab__node {
  flex: none;
  color: var(--xg-text-primary);
}

.xg-progress-tab__label {
  flex: none;
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
}

/* ★F3：详情（断点原因／纯文本消息）——单行截断，全文进 title；与对话流同源同键 */
.xg-progress-tab__detail {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--xg-text-tertiary);
  font-size: var(--xg-font-size-caption);
}

.xg-progress-tab__code {
  flex: none;
  margin-left: auto;
  color: var(--xg-state-warning-fg);
  font-size: var(--xg-font-size-caption);
}

/* ── ★PFK2R·L-PF-B5 运行态段（在跑/在等）——零字面色（一律 L2 令牌，design-guard G1/G2） ── */
.xg-progress-tab__runtime {
  flex: none;
  min-width: 0;
  padding: var(--xg-space-2xs) 0;
  border-bottom: 1px solid var(--xg-border-subtle);
}

.xg-progress-tab__runtime-head {
  margin: 0;
  padding: 0 var(--xg-space-sm);
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
}

.xg-progress-tab__runtime-list {
  margin: var(--xg-space-2xs) 0 0;
  padding: 0 var(--xg-space-sm);
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.xg-progress-tab__runtime-row {
  display: flex;
  align-items: baseline;
  gap: var(--xg-space-xs);
  font-size: var(--xg-font-size-caption);
  line-height: 20px;
  color: var(--xg-text-secondary);
}

.xg-progress-tab__runtime-src {
  flex: none;
  color: var(--xg-text-tertiary);
}

.xg-progress-tab__runtime-ref {
  flex: none;
  color: var(--xg-text-primary);
}

.xg-progress-tab__runtime-state {
  flex: none;
  color: var(--xg-text-tertiary);
}

.xg-progress-tab__runtime-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--xg-text-tertiary);
}

.xg-progress-tab__runtime-gaps {
  margin: var(--xg-space-2xs) 0 0;
  padding: 0 var(--xg-space-sm);
  color: var(--xg-state-warning-fg);
  font-size: var(--xg-font-size-caption);
}
`;

/** components/rightbar/TabBodyHost.tsx（逐字平移，零改动） */
export const tabBodyHostStyle = `
.xg-tab-body-host {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  background: var(--xg-surface-base);
}

.xg-tab-body-host__pane {
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border-right: 0.5px solid var(--xg-border-subtle);
}

.xg-tab-body-host__pane:last-child {
  border-right: none;
}
`;

/** components/rightbar/TabBodySeat.tsx（逐字平移，零改动） */
export const tabBodySeatStyle = `
.xg-tab-seat__unknown {
  margin: 0;
  padding: var(--xg-space-md);
  color: var(--xg-text-tertiary);
  font-family: var(--xg-font-family-ui);
  font-size: var(--xg-font-size-caption);
}
.xg-tab-seat-slot {
  display: contents;
}
`;

/** components/rightbar/TextTabBody.tsx（逐字平移，零改动） */
export const textTabBodyStyle = `
.xg-text-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-family: var(--xg-font-family-ui);
  font-size: var(--xg-font-size-content);
  color: var(--xg-text-primary);
}

.xg-text-tab__head {
  display: flex;
  align-items: center;
  gap: var(--xg-space-2xs);
  padding: var(--xg-space-2xs) var(--xg-space-sm);
  border-bottom: 0.5px solid var(--xg-border-subtle);
  flex: none;
  overflow-x: auto;
}

.xg-text-tab__name {
  font-size: var(--xg-font-size-caption);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 40%;
}

.xg-text-tab__size,
.xg-text-tab__lines {
  flex: none;
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-tertiary);
}

.xg-text-tab__spacer {
  flex: 1;
}

.xg-text-tab__wrap {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex: none;
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-secondary);
}

.xg-text-tab__action {
  flex: none;
  min-height: 24px;
  padding: 0 var(--xg-space-2xs);
  border: 0.5px solid var(--xg-border-subtle);
  border-radius: var(--xg-radius-chip);
  background: transparent;
  color: var(--xg-text-secondary);
  font-size: var(--xg-font-size-caption);
  cursor: pointer;
}

.xg-text-tab__action:hover,
.xg-text-tab__action:focus-visible {
  color: var(--xg-text-primary);
  border-color: var(--xg-border-focus);
}

.xg-text-tab__notice {
  margin: 0;
  padding: var(--xg-space-2xs) var(--xg-space-sm);
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-secondary);
  background: var(--xg-surface-sunken);
}

.xg-text-tab__hint,
.xg-text-tab__error {
  padding: var(--xg-space-md);
  font-size: var(--xg-font-size-caption);
}

.xg-text-tab__hint {
  color: var(--xg-text-tertiary);
}

.xg-text-tab__error {
  color: var(--xg-state-danger-fg);
}

.xg-text-tab__card {
  display: flex;
  align-items: center;
  gap: var(--xg-space-sm);
  margin: var(--xg-space-md);
  padding: var(--xg-space-sm) var(--xg-space-md);
  border: 0.5px solid var(--xg-border-subtle);
  border-radius: var(--xg-radius-block);
  background: var(--xg-surface-raised);
}

.xg-text-tab__card-icon {
  font-size: var(--xg-font-size-content);
}

.xg-text-tab__card-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.xg-text-tab__card-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.xg-text-tab__card-reason {
  font-size: var(--xg-font-size-caption);
  color: var(--xg-text-tertiary);
}

/* 文本正文：贴合格的四条边（各渲染器自带留白）；行号栏不参与选择（复制文本不含行号） */
.xg-text-tab__text {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: var(--xg-code-bg);
}

.xg-text-tab__gutter {
  flex: none;
  padding: var(--xg-space-xs) var(--xg-space-2xs);
  border-right: 0.5px solid var(--xg-border-subtle);
  color: var(--xg-text-tertiary);
  font-family: var(--xg-font-family-mono);
  font-size: var(--xg-font-size-code);
  line-height: var(--xg-line-height-code);
  text-align: right;
  white-space: pre;
  user-select: none;
}

.xg-text-tab__pre {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: var(--xg-space-xs) var(--xg-space-sm);
  color: var(--xg-code-fg);
  font-family: var(--xg-font-family-mono);
  font-size: var(--xg-font-size-code);
  line-height: var(--xg-line-height-code);
  white-space: pre;
  overflow-wrap: normal;
}

.xg-text-tab__pre--wrap {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.xg-text-tab__media {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: var(--xg-space-sm);
}

.xg-text-tab__media img {
  max-width: 100%;
  max-height: 100%;
}

.xg-text-tab__frame {
  flex: 1;
  min-height: 0;
  width: 100%;
  border: none;
  background: var(--xg-surface-base);
}
`;

/** components/RightTabStrip.tsx（逐字平移，零改动） */
export const rightTabStripStyle = `
.xg-right-tab-strip {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 1px solid var(--xg-border-subtle);
  background: var(--xg-surface-raised);
  flex-shrink: 0; min-height: var(--xg-hit-target);
  padding: 0 var(--xg-space-2xs);
}
.xg-right-tab-strip__tabs { display: flex; align-items: center; gap: 2px; overflow-x: auto; flex: 1; min-width: 0; }
.xg-right-tab-strip__tab {
  display: inline-flex; align-items: center; gap: var(--xg-space-2xs);
  padding: var(--xg-space-2xs) var(--xg-space-xs);
  border-radius: var(--xg-radius-sm) var(--xg-radius-sm) 0 0;
  background: transparent; color: var(--xg-text-secondary); cursor: pointer;
  font-size: var(--xg-font-size-caption); white-space: nowrap; min-height: var(--xg-hit-target);
}
.xg-right-tab-strip__tab--active { background: var(--xg-blue-100); color: var(--xg-text-primary); font-weight: var(--xg-fw-semibold); }
.xg-right-tab-strip__tab--progress { color: var(--xg-text-tertiary); } /* 判别钩子类保留；不斜体（★20260921） */
.xg-right-tab-strip__tab-close {
  display: inline-flex; align-items: center; justify-content: center; position: relative;
  width: 16px; height: 16px; border: none; border-radius: var(--xg-radius-xs);
  background: transparent; color: var(--xg-text-tertiary); cursor: pointer; padding: 0;
}
.xg-right-tab-strip__tab-close::after { content: ""; position: absolute; inset: -14px; } /* 命中区 ≥44 */
.xg-right-tab-strip__controls { display: flex; align-items: center; gap: 2px; flex-shrink: 0; }
.xg-right-tab-strip__ctrl {
  display: inline-flex; align-items: center; justify-content: center; position: relative;
  width: var(--xg-space-6); height: var(--xg-space-6);
  border: none; border-radius: var(--xg-radius-xs);
  background: transparent; color: var(--xg-text-tertiary); cursor: pointer; padding: 0;
}
.xg-right-tab-strip__ctrl::after { content: ""; position: absolute; inset: -10px; } /* 命中区 ≥44 */
.xg-right-tab-strip__icon { display: inline-block; vertical-align: -0.15em; flex: none; }
@media (hover: hover) {
  .xg-right-tab-strip__tab:hover { color: var(--xg-text-primary); }
  .xg-right-tab-strip__tab-close:hover { color: var(--xg-state-danger); }
  .xg-right-tab-strip__ctrl:hover { color: var(--xg-text-primary); }
}
`;

/** components/RightbarHost.tsx（逐字平移，零改动） */
export const rightbarHostStyle = `
.xg-rightbar-host { position: relative; display: flex; height: 100%; overflow: hidden; }
.xg-rightbar-host--collapsed { width: 0 !important; }
.xg-rightbar-host--fullscreen { position: fixed; inset: 0; z-index: 50; width: 100% !important; }
.xg-rightbar-host--dragging { user-select: none; }
.xg-rightbar-host__handle {
  width: var(--xg-space-2xs);
  cursor: col-resize;
  touch-action: none;
  background: transparent;
  flex-shrink: 0;
  transition: background var(--xg-dur-tap) var(--xg-ease);
}
.xg-rightbar-host__handle:focus-visible { background: var(--xg-accent); }
@media (hover: hover) {
  .xg-rightbar-host__handle:hover { background: var(--xg-accent); }
}
.xg-rightbar-host__body { flex: 1; display: flex; flex-direction: column; min-width: 0; overflow: hidden; }
`;
